(function () {
    'use strict';

    // @ngInject
    function CalendarMeetingModalControllerCtor($scope, $injector, $modalInstance, moment, _, $translate,
                                                AnalyticsService, options, UsersManager, SearchablesManager, PopupMessageService, EventService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CalendarMeetingModalController';
        AnalyticsService.trackPageView(this, 'CalendarMeetingModalView');

        this._ = _;
        this.$translate = $translate;
        this.moment = moment;
        this.$modalInstance = $modalInstance;

        //some constants
        this.DATE_FORMAT = 'MMM DD, YYYY';
        this.DATE_SERVER_FORMAT = 'YYYY-MM-DD';
        this.TIME_FORMAT = 'h:mm a';

        this.UsersManager = UsersManager;
        this.PopupMessageService = PopupMessageService;
        this.SearchablesManager = SearchablesManager;
        this.EventService = EventService;
        this.user = this.UsersManager.getCurrUser();

        this.timeStart = null;
        this.timeEnd = null;
        this.meetingTitle = null;
        this.meetingLocation = null;
        this.selectedWorkspace = null;

        this.searchingWorkspaceShow = false;
        this.searching = false;
        this.workspacesSearchText = null;
        this.searchDataBeingFetched = false;
        this.workspacesSearchResults = [];

        this.isCreateMeeting = options.isCreateMeeting;

        if(this.isCreateMeeting) {
            // populate project field when coming from a workspace
            if(options.source === 'workspace' && options.workspace_id) {
                this.setSelectedWorkspace(options);
                this.date = this.moment().format(this.DATE_FORMAT);
            }
            else if( options.source === 'headerNav') {
                this.date = this.moment().format(this.DATE_FORMAT);
            }
            else {
                // populate date field when coming from calendar
                this.date = options.dateTimeStart.format(this.DATE_FORMAT);

                if(options.viewType === 'agendaWeek' || options.viewType === 'agendaDay'){
                    //auto-populate the start and end time
                    if (!options.allDay) {
                        this.timeStart = options.dateTimeStart.format(this.TIME_FORMAT);
                        this.timeEnd = options.dateTimeStart.add(1, 'hour').format(this.TIME_FORMAT);
                    }
                }
            }
        }
        else {
            var momentTimeStart = this.moment(options.calendarItemModel.date_time_start);
            var momentTimeEnd = this.moment(options.calendarItemModel.date_time_end);

            this.editingCalendarItemId = options.calendarItemModel._id;
            this.meetingTitle = options.calendarItemModel.title;
            this.meetingLocation = options.calendarItemModel.location;

            if (!options.calendarItemModel.all_day) {
                this.date = momentTimeStart.format(this.DATE_FORMAT);
                this.timeStart = momentTimeStart.format(this.TIME_FORMAT);
                this.timeEnd = momentTimeEnd.format(this.TIME_FORMAT);
            } else {
                this.date = this.moment(options.calendarItemModel.date_start, this.DATE_SERVER_FORMAT).format(this.DATE_FORMAT);
            }

            if (options.calendarItemModel.workspace_id) {
                this.setSelectedWorkspace(options.calendarItemModel);
            }
        }
        this.dateError = false;
        this.searchingWorkspace = false;
        this.createingCalendarItem = false;
        this.updatingCalendarItem = false;
    }

    Controllers.CalendarMeetingModalController = Class(Controllers.BaseController, {
        constructor: CalendarMeetingModalControllerCtor,

        cancelCreateMeting: function cancelCreateMeting(){
            this.$modalInstance.dismiss();
        },

        isDateValid: function isDateValid(){
            var dateAsMoment = this.moment(this.date, [this.DATE_FORMAT], true);
            if(dateAsMoment.isValid()){
                this.dateError = false;
            }
            else{
                this.dateError = true;
            }

            return !this.dateError;
        },

        workspaceSearchInputChanged: function workspaceSearchInputChanged() {
            if (this.workspacesSearchText && this.workspacesSearchText.length >= 3) {
                this.searchDataBeingFetched = true;
                this.workspacesSearchResults = this.SearchablesManager.search(this.workspacesSearchText, 'couple_cards', {hideTeamMembers: true});
                this.register(this.workspacesSearchResults, 'success', function onSearchDataFetched(callbackReason) {
                    this.searchDataBeingFetched = false;
                    this.isSearchTriggered = true;
                }.bind(this));
            }else{
                this.workspacesSearchResults = [];
            }
        },

        clearSearch: function clearSearch($event) {
            this.workspacesSearchText = null;
            this.workspacesSearchResults = [];
            this.selectedWorkspace = null;

            if($event){
                $event.preventDefault();
                $event.stopPropagation();
            }
        },

        handleWorkspaceItemSelected: function handleWorkspaceItemSelected(workspaceSearchItem){
            this.searchingWorkspaceShow = false;

            this.selectedWorkspace = workspaceSearchItem;
            this.workspacesSearchText = workspaceSearchItem.properties.event_name;
            this.searching = false;
        },

        selectedWorkspaceName: function selectedWorkspaceName() {
            if (this.selectedWorkspace === null) {
            	return "Search for event";
            } else {
                return this.selectedWorkspace.properties.event_name;
            }
        },

        prepareMeetingParams: function prepareMeetingParams() {
            var momentTimeStart = this.timeStart ? this.moment(this.timeStart, this.TIME_FORMAT) : null;
            var momentTimeEnd = this.timeEnd ? this.moment(this.timeEnd, this.TIME_FORMAT) : null;

            var objectToReturn = {
                title: this._.isEmpty(this.meetingTitle) ?
                    this.$translate.instant('REPORTS.CALENDAR.MEETING_MODAL._NO_MEETING_TITLE_DEFAULT_') :
                    this.meetingTitle,

                all_day: (!momentTimeStart || !momentTimeEnd) || (momentTimeStart && momentTimeEnd && momentTimeStart.isSameOrAfter(momentTimeEnd)),

                workspace_id: (this.selectedWorkspace ? this.selectedWorkspace._id : null),
                event_id: (this.selectedWorkspace ? this.selectedWorkspace.properties.event_id : null),
                location: this.meetingLocation
            };

            if (!objectToReturn.all_day) {
                objectToReturn.date_time_start = momentTimeStart ? (this.moment(this.date, this.DATE_FORMAT).set({
                    'hour': momentTimeStart.get('hour'),
                    'minute': momentTimeStart.get('minute'),
                    'second': momentTimeStart.get('second')
                }).toString()) : this.moment(this.date, this.DATE_FORMAT).toString();

                objectToReturn.date_time_end = momentTimeEnd ? (this.moment(this.date, this.DATE_FORMAT).set({
                    'hour': momentTimeEnd.get('hour'),
                    'minute': momentTimeEnd.get('minute'),
                    'second': momentTimeEnd.get('second')
                }).toString()) : this.moment(this.date, this.DATE_FORMAT).toString();
            } else {
                objectToReturn.date_start = this.moment(this.date, this.DATE_FORMAT).format(this.DATE_SERVER_FORMAT);
                //in the future we may add date_end to support multiple all-day calendarItems
            }

            return objectToReturn;
        },

        handleCreateCalendarMeeting: function handleCreateCalendarMeeting() {
            this.creatingCalendarItem = true;
            var meetingParams = this.prepareMeetingParams();
            this.UsersManager.createCalendarsItem(this.user, meetingParams)
                .then(function success(resp) {
                    this.$modalInstance.close(resp.data);
                }.bind(this))
                .catch(function fail(error) {
                    var errorMsg;
                    if(error && error.data && error.date.error_message === 'invalid date') {
                        errorMsg = 'REPORTS.CALENDAR.MEETING_MODAL.ERRORS._MISSING_DATE_FIELD_';
                    } else {
                        errorMsg = 'REPORTS.CALENDAR.MEETING_MODAL.ERRORS._COULD_NOT_CREATE_THIS_MEETING_';
                    }
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, errorMsg);
                }.bind(this))
                .finally(function finallyHandler() {
                    this.creatingCalendarItem = false;
                }.bind(this));
        },

        handleUpdateCalendarMeeting: function handleUpdateCalendarMeeting() {
            this.updatingCalendarItem = true;
            var meetingParams = this.prepareMeetingParams();
            this.UsersManager.updateCalendarItem(this.user, this.editingCalendarItemId, meetingParams)
                .then(function success(resp) {
                    this.$modalInstance.close(resp.data);
                }.bind(this))
                .catch(function fail(error) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'REPORTS.CALENDAR.MEETING_MODAL.ERRORS._COULD_NOT_FIND_THIS_MEETING_');
                }.bind(this))
                .finally(function finallyHandler() {
                    this.updatingCalendarItem = false;
                }.bind(this));
        },

        handleClickOutsideSearch: function handleClickOutsideSearch() {
            if (!this.selectedWorkspace) {
                this.clearSearch();
            } else {
                this.workspacesSearchText = this.selectedWorkspace.properties.event_name;
            }

            this.searching = false;
        },

        handleSearchFocused: function handleSearchFocused() {
            this.searching = true;
        },

        searchWorkspace: function searchWorkspace($event) {
            $event.preventDefault();
            $event.stopPropagation();
            this.searchingWorkspaceShow = true;
        },

        setSelectedWorkspace: function setSelectedWorkspace(workspaceData) {
            this.selectedWorkspace = {
                _id: workspaceData.workspace_id,
                properties: {
                    event_id: workspaceData.event_id,
                    event_name: workspaceData.event_name
                }
            };
            //update the search text to reflect the selected workspace (but show the event name since workspace does not always have tab_name)
            this.workspacesSearchText = this.selectedWorkspace.properties.event_name;
        },

        createNewProject: function createNewProject() {
            this.createProjectInProgress = true;
            var config = {doNotGoToNewWorkspace: true };
            this.EventService.createEventCommand(config)
                .then(function success(resp) {
                    if (resp) {
                        this.selectedWorkspace = {
                            _id: resp._id,
                            properties: {
                                event_id: resp.event._id,
                                event_name: resp.event.event_name
                            }
                        };
                        this.workspacesSearchText = resp.event.event_name;
                    }
                }.bind(this)).finally(function () {
                this.createProjectInProgress = false;
            }.bind(this));
        }
    });
}());
